module.exports = __webpack_public_path__ + "img/header.a8dd7e32.jpg";